import { FC, useRef } from 'react';
import classNames from 'classnames';
import styles from './textArea.module.scss';

const TextArea: FC<TeaxtAreaProps> = (props: TeaxtAreaProps) => {
    const {
        defaultValue,
        onChange,
        extraClass,
        showIcon = true,
        isLight = false,
        rows = 1,
        style = {},
        placeholder,
        maxLength,
        errorMessage
    } = props;

    const textAreaRef = useRef() as React.MutableRefObject<HTMLTextAreaElement>;

    return (
        <div>
            <textarea
                ref={textAreaRef}
                defaultValue={defaultValue}
                onChange={e => onChange(e.target.value)}
                className={classNames(
                    styles.wrapper,
                    showIcon && styles['input-icon'],
                    extraClass,
                    isLight && styles.light
                )}
                rows={rows}
                style={style}
                placeholder={placeholder}
                maxLength={maxLength}
            />
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
        </div>
    );
};

interface TeaxtAreaProps {
    defaultValue: string;
    onChange: Function;
    extraClass?: string;
    showIcon?: boolean;
    isLight?: boolean;
    style?: object;
    rows?: number;
    placeholder?: string;
    maxLength?: number;
    errorMessage?: string;
}

export default TextArea;
